import { useCallback } from 'react';
import { useLazyGetAnalyticsFolderQuery } from '@/store/api';
/**
 * Platform-services lazy-query hook for fetching the default analytics folder on demand.
 *
 * @see src/store/api/cc/analyticsApi.ts
 */
export const useLazyGetAnalyticsFolder = () => {
    const [trigger, { data, isLoading, isFetching, isError, error, }] = useLazyGetAnalyticsFolderQuery();
    const triggerGetAnalyticsFolder = useCallback(() => trigger().unwrap(), [trigger]);
    return {
        triggerGetAnalyticsFolder,
        data,
        isLoading: isLoading || isFetching,
        isError,
        error,
    };
};
